export default __webpack_public_path__ + "static/media/tutorialWeb-4.5.bee0fa59.png";